"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _bs = require("react-icons/bs");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilterChip = function FilterChip(props) {
  var className = props.className,
      content = props.content,
      onClick = props.onClick,
      tooltip = props.tooltip;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "content-chip",
    title: tooltip || content
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "text-chip"
  }, content), /*#__PURE__*/_react.default.createElement("button", {
    type: "button",
    className: "btn-delete ".concat(className),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_bs.BsXCircle, null)));
};

FilterChip.propTypes = {
  content: _propTypes.default.string.isRequired,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func.isRequired,
  tooltip: _propTypes.default.string
};
FilterChip.defaultProps = {
  className: '',
  tooltip: ''
};
var _default = FilterChip;
exports.default = _default;